<template>
  <div class="update-container">
    <Personal action="update" ref="personal">
      <template #header>
        <WorkbenchTitle class="header" title="个人信息修改" />
      </template>
      <template #footer="{ user }">
        <div class="input-container">
          <button class="register-btn" @click="updateUser(user)">修改</button>
        </div>
      </template>
    </Personal>
  </div>
</template>
<script>
import Personal from "@/components/Personal";
import WorkbenchTitle from "@/components/WorkbenchTitle";
import { fetchUpdateUserInfo } from "@/api/user";
import { getToken } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  name: "ChangeInfo",
  data() {
    return {};
  },
  components: {
    Personal,
    WorkbenchTitle,
  },
  computed: {
    ...mapState("user", ["role", "platform"]),
  },
  methods: {
    async updateUser(user) {
      console.log("refs", this.$refs.personal);
      let validStatus = this.$refs.personal.checkSubmitParams(user);

      if (validStatus) {
        const params = {
          avatar: user.avatar,
          name: user.userName,
          id_card: user.IDCardNo,
          email: user.email,
          code: user.msgCode,
          hospital_name: user.hospital,
          department_name: user.department,
          platform: this.platform,
          role: this.role,
          common_token: getToken(),
          career_name: user.career_name,
          category: user.category,
          position: user.position
        };

        const loadingInstance = this.$loading();
        const { code, msg } = await fetchUpdateUserInfo(params);
        loadingInstance.close();

        if (code === 0) {
          this.$router.go(0);
          this.$message({ message: "个人信息修改成功", type: "success" });
        } else {
          this.$message({ message: msg, type: "error" });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
